"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _baseClient = _interopRequireDefault(require("./baseClient"));
// since pass `config` can contain a client secret, hide this in a closure
const clientConfigs = new _map.default();
class TmcClient extends _baseClient.default {
  init(config) {
    config = {
      ...config
    };
    let tmcConfig;
    if (config.token) {
      // derive config details from raw token
      const token = new config.TMC.auth.JsonWebToken(config.token);
      config.clientId = token.clientId;
      tmcConfig = config.token;

      // confirm the raw token matches expected domain
      if (token.base !== config.baseDomain) {
        throw new Error(`token domain "${token.base}" does not match expected "${config.baseDomain}"`);
      }
    } else {
      tmcConfig = {
        ...config
      };
      tmcConfig.base = config.baseDomain;
      delete tmcConfig.TMC;
      delete tmcConfig.baseDomain;
    }
    super.init(config);
    this._TMC = config.TMC;
    clientConfigs.set(this.clientId, tmcConfig);
    this._initialized = true;
  }
  async logIn() {
    super.logIn();
    const {
      transporter,
      token
    } = await this._TMC.auth(clientConfigs.get(this.clientId));
    await token.getLiveAccessToken(); // prime in case token string is a refresh token
    this._transporter = transporter;
    this._token = token; // token keeper instance
    this._onAuthRefreshSuccess();
    token.onAccessTokenRefresh(() => this._onAuthRefreshSuccess());
    const accountTransporter = new this._TMC.common.network.ServiceTransporter({
      subDomain: 'accounts'
    });
    this._userInfo = (await accountTransporter.get('v1/auth/oidc/userinfo')).data;
    clientConfigs.delete(this.clientId);
    this._loggedIn = true;
  }
  logOut() {
    // NOTE: that instantiated services and endpoints will work for the remaining
    // life of the access token
    this._TMC.clear();
    this._loggedIn = false;
  }

  // specific to TmcClient
  get transporter() {
    return this._transporter;
  }
  _onAuthRefreshSuccess() {
    const {
      accessToken,
      refreshToken
    } = this._token;
    this._accessToken = accessToken.toString();
    this._accessTokenPayload = accessToken.payload;
    if (refreshToken) {
      // refresh token not returned any longer for `client_credentials` grant
      this._refreshToken = refreshToken.toString();
      if (refreshToken.payload) {
        this._refreshTokenPayload = refreshToken.payload;
      }
    }
    super._onAuthRefreshSuccess();
  }
}
exports.default = TmcClient;